import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import { THEME_SETTING } from "../../pages/trivia/data";
import "./rangeInput.css";
export default function RangeInput({
  min,
  max,
  value,
  onChange = () => {},
  className,
  themeSettings = THEME_SETTING,
  options = [],
}) {
  const [array, setArray] = useState([...Array(max).keys()].map((i) => i + 1));

  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    if (max) {
      let arr = [
        ...Array(typeof max == "string" ? parseInt(max) : max).keys(),
      ].map((i) => i + 1);
      arr = arr.filter((x) => x >= min);
      setArray(arr);
    }
  }, [max, min]);

  const handleRadioChange = (val) => {
    setSelectedValue(val); // Update selected value
    onChange(val); // Notify parent component of the change
  };

  return (
    <div className={`rangeInput_wrapper ${className}`}>
      {array.map((x, index) => {
        const isSelected = value >= x;
        return (
          <div key={index} className={`rangeInput_radio_wrapper`}>
            <input
              type="radio"
              id={`radio-${x}`}
              name="rangeInputRadio" // Ensure all radios share the same name
              value={x}
              checked={selectedValue === x} // Mark as selected if matches
              onChange={() => handleRadioChange(x)}
            />
            <label htmlFor={`radio-${x}`}>
              {options[x - 1] ? options[x - 1].text : x}{" "}
              {/* Show options or the value */}
              {index == 0
                ? "Lowest"
                : index === array.length - 1
                ? "Highest"
                : ""}
            </label>
          </div>

          // <div
          // key={index}
          //   className={`rangeInput_number_box`}
          //   onClick={() => onChange(x)}
          //   style={{
          //     background:isSelected?themeSettings.quizTextColor:"white",
          //     color:isSelected?"white":themeSettings.quizTextColor
          //   }}
          //   data-tip={options[x-1] && options[x-1].text || ""}
          // >

          //   {x}
          // </div>
        );
      })}
    </div>
  );
}
